import { createFileRoute } from '@tanstack/react-router';
import { FaqAdminPage } from '@/features/help-center/faq/admin/FaqAdminPage';

export const Route = createFileRoute('/admin/help-center/faq')({
  component: FaqAdminPage,
});
